@if (component) {
<div class="flex flex-middle"
     [ngClass]="align">
    @switch (component.buttonType) {
    @case ('inline') {
    <href [link]="component.url || ''">
        <button inlineButton>
            <span *iCms="'label' of component"></span>
        </button>
    </href>
    }
    @case ('text') {
    <href [link]="component.url || ''">
        <button [buttonStyle]="'inlineButton'">
            <span *iCms="'label' of component"></span>
        </button>
    </href>
    }
    @default {
    <href [link]="component.url || ''">
        <button [buttonStyle]="component.buttonStyle || 'default'">
            <span *iCms="'label' of component"></span>
        </button>
    </href>
    }
    }
</div>
}